// extracted by mini-css-extract-plugin
export default {"customPhoneInput":"custom-phone-input_customPhoneInput__Pcbb+","customSelect":"custom-phone-input_customSelect__iqjlY"};